
// export const samer = "";
export const BaseUrl = "https://system.kwick-box.com/api/";
export const AmsBaseUrl = "https://ams.kwick-box.com/api/";
export const GoogleMapsApiKey = 'AIzaSyBVpqgwvUDtznbA74DbRjM4t3tQhqQkZ8g';

//export const JorBaseUrl = "https://stg.kwick-box.com/api/";
// export const KsaBaseUrl = "https://system-stg.kwick-box.com/api/";